import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { userAPI } from '../api/api';
import { formatDateForDisplay } from '../utils/dateUtils';
import './UserLoginLogs.css';

const UserLoginLogs = () => {
  const { token } = useAuth();
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [loginHistories, setLoginHistories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingHistory, setLoadingHistory] = useState(false);

  useEffect(() => {
    if (token) {
      loadUsers();
    }
  }, [token]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const data = await userAPI.getAll();
      setUsers(data);
    } catch (error) {
      console.error('Error loading users:', error);
      alert('Kullanıcılar yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const loadLoginHistory = async (userId) => {
    setLoadingHistory(true);
    try {
      const history = await userAPI.getUserLoginHistory(userId);
      setLoginHistories(history || []);
    } catch (error) {
      console.error('Error loading login history:', error);
      alert('Giriş geçmişi yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
      setLoginHistories([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    loadLoginHistory(userId);
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    // UTC+3 (Istanbul) timezone için formatDateForDisplay kullan
    return formatDateForDisplay(dateString);
  };

  if (loading) {
    return <div className="logs-container"><div className="loading">Yükleniyor...</div></div>;
  }

  return (
    <div className="logs-container">
      <div className="page-header">
        <h1>Kullanıcı Giriş Logları</h1>
      </div>

      <div className="logs-content">
        <div className="logs-sidebar">
          <h3>Kullanıcılar</h3>
          <div className="user-list">
            {users.map((user) => (
              <div
                key={user.Id || user.id}
                className={`user-item ${selectedUserId === (user.Id || user.id) ? 'active' : ''}`}
                onClick={() => handleUserSelect(user.Id || user.id)}
              >
                {user.Name || user.name} {user.Surname || user.surname}
              </div>
            ))}
          </div>
        </div>

        <div className="logs-main">
          {selectedUserId ? (
            <>
              <h3>Giriş Geçmişi</h3>
              {loadingHistory ? (
                <div className="loading">Yükleniyor...</div>
              ) : loginHistories.length === 0 ? (
                <div className="no-data">Bu kullanıcı için giriş kaydı bulunmamaktadır.</div>
              ) : (
                <div className="logs-table-container">
                  <table className="logs-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>IP Adresi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loginHistories.map((log) => (
                        <tr key={log.Id || log.id}>
                          <td>{formatDateTime(log.LoginDate || log.loginDate)}</td>
                          <td>{log.IpAddress || log.ipAddress || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : (
            <div className="no-selection">Lütfen bir kullanıcı seçin</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLoginLogs;

